import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { DEVICE_BREAKPOINTS_MAP, DESKTOP } from './constants';

const BreakpointManagerContext = createContext({
    status: {
        breakpoint: undefined,
        breakpointWidth: undefined,
    },
    actions: {
        setBreakpoint: () => {},
        resetBreakpoint: () => {},
    },
});

function BreakpointManagerProvider({ children }) {
    const [breakpoint, setBreakpoint] = useState(DESKTOP);

    const resetBreakpoint = () => setBreakpoint(DESKTOP);

    const value = {
        status: {
            breakpoint,
            breakpointWidth: DEVICE_BREAKPOINTS_MAP[breakpoint],
        },
        actions: {
            setBreakpoint,
            resetBreakpoint,
        },
    };

    return <BreakpointManagerContext.Provider value={value}>{children}</BreakpointManagerContext.Provider>;
}

BreakpointManagerProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useBreakpointManager = () => useContext(BreakpointManagerContext);

export default BreakpointManagerProvider;
